import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router';

import { useIsomorphicLayoutEffect } from '#/hooks/useIsomorphicLayoutEffect';
import { useViewportSizeEffect } from '#/hooks/viewport/useViewportSizeEffect';
import { postEmbedSearchWidgetMessage } from '#/modules/embedSearchWidget/utils/postEmbedSearchWidgetMessage';

export function useEmbedSearchWidgetResize() {
  const postResizeMessage = useCallback(() => {
    postEmbedSearchWidgetMessage({
      type: 'idealist-resize',
      height: document.body.getBoundingClientRect().height,
    });
  }, []);

  useViewportSizeEffect(postResizeMessage);

  const location = useLocation();

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      postResizeMessage();
    });

    resizeObserver.observe(document.body);
  }, [postResizeMessage]);

  useEffect(() => {
    window.addEventListener('resize', postResizeMessage);

    return () => {
      window.removeEventListener('resize', postResizeMessage);
    };
  }, [postResizeMessage]);

  useIsomorphicLayoutEffect(() => {
    postResizeMessage();
  }, [location.pathname, postResizeMessage]);
}
